// Service zum Abrufen und Parsen der XML-Daten über Firebase Cloud Function Proxy

// Firebase Cloud Function URL
const getFirebaseUrl = () => {
  // Verwende immer die Production URL, da die Function deployed ist
  return 'https://us-central1-clone-2c39d.cloudfunctions.net/getNewsXML';
  
  // Falls Sie den lokalen Emulator verwenden möchten, kommentieren Sie die obige Zeile aus
  // und aktivieren Sie die folgenden Zeilen:
  // if (window.location.hostname === 'localhost') {
  //   return 'http://localhost:5001/clone-2c39d/us-central1/getNewsXML';
  // }
  // return 'https://us-central1-clone-2c39d.cloudfunctions.net/getNewsXML';
};

/**
 * Fetch und parse XML über Firebase Cloud Function
 */
const fetchAndParseXML = async (type, tid = null) => {
  try {
    let url = `${getFirebaseUrl()}?type=${type}`;
    if (tid) {
      url += `&tid=${tid}`;
    }

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const xmlText = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, 'text/xml');
    
    // Check for parsing errors
    const parserError = xmlDoc.querySelector('parsererror');
    if (parserError) {
      throw new Error('XML parsing error');
    }
    
    return xmlDoc;
  } catch (error) {
    console.error('Error fetching XML:', error);
    throw error;
  }
};

/**
 * Hole die News-Übersicht
 */
export const fetchNewsOverview = async () => {
  try {
    const xmlDoc = await fetchAndParseXML('overview');
    const articles = xmlDoc.querySelectorAll('contentItem');
    
    return Array.from(articles).map(article => {
      const imageElement = article.querySelector('image');
      return {
        id: article.querySelector('articleId')?.textContent || '',
        title: article.querySelector('headline')?.textContent || '',
        date: article.querySelector('periode')?.textContent || '',
        teaser: article.querySelector('subheadline')?.textContent || '',
        category: article.querySelector('periode')?.textContent || '',
        image: imageElement?.textContent || ''
      };
    });
  } catch (error) {
    console.error('Error fetching news overview:', error);
    return [];
  }
};

/**
 * Hole das News-Archiv
 */
export const fetchNewsArchive = async () => {
  try {
    const xmlDoc = await fetchAndParseXML('archive');
    const articles = xmlDoc.querySelectorAll('contentItem');
    
    return Array.from(articles).map(article => {
      const imageElement = article.querySelector('image');
      return {
        id: article.querySelector('articleId')?.textContent || '',
        title: article.querySelector('headline')?.textContent || '',
        date: article.querySelector('periode')?.textContent || '',
        teaser: article.querySelector('subheadline')?.textContent || '',
        category: article.querySelector('periode')?.textContent || '',
        image: imageElement?.textContent || ''
      };
    });
  } catch (error) {
    console.error('Error fetching news archive:', error);
    return [];
  }
};

/**
 * Hole einen einzelnen Artikel mit Details
 */
export const fetchArticleDetails = async (tid) => {
  try {
    const xmlDoc = await fetchAndParseXML('article', tid);
    const article = xmlDoc.querySelector('contentItem');
    
    if (!article) {
      throw new Error('Article not found');
    }

    // Parse images - in dieser API sind Images direkt als Text im <image> Tag
    const imageElements = Array.from(article.querySelectorAll('image'));
    const images = imageElements.map(img => ({
      url: img.textContent || '',
      caption: ''
    }));

    // Parse signets - direkt als Text im <signet> Tag
    const signetElements = Array.from(article.querySelectorAll('signet'));
    const signets = signetElements.map(sig => ({
      url: sig.textContent || '',
      alt: 'Signet'
    }));

    return {
      id: article.querySelector('articleId')?.textContent || '',
      title: article.querySelector('headline')?.textContent || '',
      date: article.querySelector('periode')?.textContent || '',
      category: article.querySelector('periode')?.textContent || '',
      teaser: article.querySelector('subheadline')?.textContent || '',
      content: article.querySelector('text')?.textContent || '',
      images,
      signets
    };
  } catch (error) {
    console.error('Error fetching article details:', error);
    throw error;
  }
};

